import { Paragraph } from "../Paragraph";

export const ReviewStatusPill = ({
  label,
  color = "gray.60",
  bgColor = "gray.10",
}: {
  label: string;
  color?: string;
  bgColor?: string;
}) => {
  return (
    <Paragraph
      px={3}
      py={1}
      mb={0}
      mt={0}
      borderRadius={20}
      backgroundColor={bgColor}
      color={color}
      fontWeight={500}
      fontSize={1}
      display="inline-block"
    >
      {label}
    </Paragraph>
  );
};
